import React from 'react';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';

export const ManagerButtons = ({ accountingSettlement, handleOpenConfirmDialog, canAddBlock, handleOpenAddBlockDialog, canAddAdditionalFee, handleOpenAdditionalFeeDialog, handleClose }) => {
    return (
        <>
            {accountingSettlement?.statementFinished && (
                <MenuItem onClick={() => { handleClose(); handleOpenConfirmDialog("Odblokuj do edycji", "Czy potwierdzasz, że chcesz odblokować zestawienie do edycji?", "unlock", true); }}>
                    <ListItemIcon><i className="fas fa-lock-open" style={{ color: '#f59e0b', fontSize: '1.2rem' }}></i></ListItemIcon>
                    <ListItemText primary="Odblokuj do edycji" />
                </MenuItem>
            )}
            {accountingSettlement?.statementFinished && accountingSettlement?.isDeclarationSent && (
                <MenuItem onClick={() => { handleClose(); handleOpenConfirmDialog("Odblokuj faktury", `Czy potwierdzasz, że chcesz odblokować proces?`, "unlockDeclaration", true); }}>
                    <ListItemIcon><i className="fas fa-file-invoice" style={{ color: '#f59e0b', fontSize: '1.2rem' }}></i></ListItemIcon>
                    <ListItemText primary="Odblokuj faktury" />
                </MenuItem>
            )}
            {canAddBlock && (
                <MenuItem onClick={() => { handleClose(); handleOpenAddBlockDialog(); }}>
                    <ListItemIcon><i className="fas fa-ban" style={{ color: '#ef4444', fontSize: '1.2rem' }}></i></ListItemIcon>
                    <ListItemText primary="Dodaj blokadę" />
                </MenuItem>
            )}
            {canAddAdditionalFee && (
                <MenuItem onClick={() => { handleClose(); handleOpenAdditionalFeeDialog(); }}>
                    <ListItemIcon><i className="fas fa-money-bill-wave" style={{ color: '#8b5cf6', fontSize: '1.2rem' }}></i></ListItemIcon>
                    <ListItemText primary="Dodatkowa opłata" />
                </MenuItem>
            )}
        </>
    );
};